import Button from "@components/_Revamp/Button";
import { InputGroup } from "@components/_Revamp/InputGroup";
import { TitleAndDescription } from "@components/_Revamp/TitleAndDescription/TitleAndDescription";
import { styled } from "@linaria/react";
import useForm from "@utils/useForm";
import React, { useEffect, useRef, useState } from "react";
import { ITheme, themeDefault, useTheme } from "src/theme-revamp";
import { validate } from "./service";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { get, isEmpty } from "lodash";
import { SubmitSuccess } from "./components/SubmitSuccess";
import { setLoadingState } from "@redux/slices/loadingSlice";
import { Helpers } from "@utils/helpers";
import { postContactCCP } from "@api/index";
import Link from "@components/_Revamp/Link";
import Contactus from "@pages/CCP/components/Contactus";
import { CONTAINER_SIZE, SCREEN_SIZE } from "@static/screen-size";
import HealthMainContainer from "@components/_Revamp/HealthMainContainer";
import {
  ContactInfo,
  updateContactDetail,
} from "@redux/slices/CCP/contactSlice";
import { css } from "@linaria/core";
import {
  trackOnCTA,
  trackOnFormStartOrSuccess,
  trackOnLoad,
} from "@pages/CCP/Helpers/analyticsHelper";

const SubmitNote = styled.p<{ theme: ITheme }>`
  color: ${(props) => props.theme.colors.grey[1400]};
  font-size: 12px;
  width: 100%;
  max-width: 744px;
  font-weight: 500;
  line-height: 19.2px;
  letter-spacing: 0.18px;
  span {
    color: #883E89;
    font-weight: 500;
    letter-spacing: 0.18px;
  }
  a {
    font-weight: 600;
    line-height: 19.2px;
    font-size: 12px;
    letter-spacing: 0.18px;
    color: #883E89;
    u {
      color: #883E89;
      border-bottom: 1px solid #883E89;
    }
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    /* padding: 0 24px; */
  }
`;

const FormActionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 24px;
  margin-bottom: 64px;
`;

const ContacFormContainer = styled.div`
  margin: 0 auto 50px auto;

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    max-width: ${CONTAINER_SIZE.desktops}px;
    padding: 0 24px;
  }
`;

const ContactInputContainer = styled.div`
  background-color: white;
  padding: 24px;
  border-radius: 8px;
  margin: 56px 0;
  display: flex;
  gap: 16px;
  flex-direction: column;
`;

export const createContactRequest = (
  form: ContactInfo,
  transactionId: number | string,
  agentCode: string | null = null,
  campaignCode: string = ""
) => {
  const content = {
    email: form.email,
    fullName: form.fullName,
    salutation: Helpers.getSalutationByCode(form.salutation || ""),
    dateOfBirth: form.dateOfBirth,
    mobileNumber: form.mobileNumber,
    agentCode: agentCode || form.agentCode,
  };

  return {
    transactionId,
    ...content,
    cc: campaignCode,
    dropPoint: "QNB_CCP_CONTACTUS",
    rentalPostalCustomer: "",
    product: "CANCERCOVERPLUS",
  } as ContactInfo;
};

export const getTimestamp = () => {
  const pad = (i: number) => {
    return i < 10 ? "0" + i : i;
  };

  const d = new Date();
  const Y = d.getFullYear();
  const m = d.getMonth() + 1;
  const D = d.getDate();
  const H = d.getHours();
  const M = d.getMinutes();
  const S = d.getSeconds();
  const ms = ("00" + d.getMilliseconds()).slice(-3);
  return `` + Y + pad(m) + pad(D) + pad(H) + pad(M) + pad(S) + ms;
};

export const ContactForm = () => {
  const urlParams: URLSearchParams = Helpers.getURLSearchParams();
  const previousPage: string = urlParams.get("previous") || "";
  const title =
    previousPage === "reachLimit"
      ? "We have sold old the tranche for this cycle, join our waitlist!"
      : "We're here to help";
  const description =
    "Fill in your contact details and we'll be in touch to address your queries.";

  const theme = useTheme();

  const dispatch = useAvivaDispatch();
  const contactInfo = useAvivaSelector(
    (state) => state.cancerCoverContact.contactInfo
  );
  const transactionId = useAvivaSelector(
    (state) => state.cancerCoverStep1.transactionId || ""
  );

  const [isPageLoaded, setIsPageLoaded] = useState<boolean>();
  const basicDetails = useAvivaSelector(
    (state) => state.cancerCoverStep4.myInfo
  );

  const [formSubmited, setFormSubmited] = useState<boolean>(false);
  const agentCodeUrl =
    useAvivaSelector((state) => state.urlAnalytic?.param?.arc) || null;

  const { values, errors, handleChange, formValid, patchValue } = useForm(
    contactInfo,
    () => {},
    validate
  );
  const ContactUsUrl = get(window, "AVIVA_VARIABLE_CONFIG.avivaContactUsUrl");
  const isTrackingForm: any = useRef<boolean>(false);
  const onFocusField: any = () => {
    if (!isTrackingForm.current) {
      trackOnFormStartOrSuccess("ccp_contact_us_form");
      isTrackingForm.current = true;
    }
  };
  const agentCode = agentCodeUrl || urlParams.get("arc");
  const campaignCode = useAvivaSelector(
    (state) => state.loading.campaignDetail?.campaignCode || ""
  );

  const onInputChange = (fieldName: keyof ContactInfo, e: any) => {
    const value =
      fieldName === "fullName"
        ? e.target.value.replace(/[^a-z\s]/gi, "")
        : e.target.value;
    console.log("onInputChange", value);
    dispatch(updateContactDetail({ [fieldName]: value }));
    handleChange(e);
  };

  const onSubmit = async () => {
    dispatch(setLoadingState(true));
    setFormSubmited(true);
    console.log("values", values);
    const payload: any = createContactRequest(
      values,
      transactionId,
      agentCode?.replaceAll(" ", "") || agentCode,
      campaignCode
    );
    try {
      const response = await postContactCCP(payload);
      trackOnCTA({
        ctaText: "Next",
        ctaType: "qb:link",
      });
      console.debug(response);
      Helpers.clearCached();
      dispatch(setLoadingState(false));
      trackOnFormStartOrSuccess("ccp_contact_us_form", true)

    } catch (error) {
      console.error(error);
      dispatch(setLoadingState(false));
    }
  };

  useEffect(() => {
    if (isPageLoaded === undefined) {
      const hasMyInfo = basicDetails.customerId;
      setIsPageLoaded(true);
      if (hasMyInfo) {
        patchValue({
          fullName: basicDetails?.fullName,
          mobileNumber: basicDetails?.mobileNum,
          email: basicDetails?.emailId,
          salutation: basicDetails?.salutation,
        });
      }
    }
  }, [
    basicDetails.customerId,
    basicDetails?.emailId,
    basicDetails?.fullName,
    basicDetails?.mobileNum,
    basicDetails?.salutation,
    isPageLoaded,
    patchValue,
  ]);

  useEffect(() => {
    trackOnLoad();
  }, []);

  return !formSubmited ? (
    <HealthMainContainer stepList={[]}>
      <>
        <div>
          <TitleAndDescription
            title={title}
            description={description}
            margin="0"
          />
        </div>
        <ContacFormContainer>
          <ContactInputContainer>
            <InputGroup
              labelColor="#434343"
              id="salutation"
              name="salutation"
              label="Salutation"
              inputType="dropdown"
              onFocus={onFocusField}
              onChange={(e) => {
                onInputChange("salutation", e);
              }}
              placeholder="Please select"
              dropdownProps={{
                value: values["salutation"],
                source: [
                  { id: "Mr", label: "Mr" },
                  { id: "Mrs", label: "Mrs" },
                  { id: "Ms", label: "Ms" },
                  { id: "Master", label: "Master" },
                  { id: "Mdm", label: "Mdm" },
                  { id: "Dr", label: "Dr" },
                ],
              }}
              theme={themeDefault}
            />
            <InputGroup
              labelColor="#434343"
              id="fullName"
              name="fullName"
              label="Full Name"
              placeholder="John"
              onFocus={onFocusField}
              onChange={(e: any) => {
                onInputChange("fullName", e);
              }}
              invalid={!isEmpty(errors?.fullName?.message)}
              errorMessage={errors?.fullName?.message}
              inputProps={{
                textAlign: "left",
                value: values["fullName"],
              }}
              inputType={"input"}
              theme={themeDefault}
              onBlurShowError={true}
            />
            <InputGroup
              inputPropsForInputBox={{
                inputMode: "tel",
                inputType: "tel",
              }}
              id="mobileNumber"
              onFocus={onFocusField}
              name="mobileNumber"
              label="Mobile Number"
              placeholder=""
              mobCode="+65"
              theme={themeDefault}
              onChange={(e) => {
                if (/^(8|9){1}[0-9]{0,7}$/.test(e.target.value))
                  onInputChange("mobileNumber", e);
              }}
              invalid={!Boolean(errors?.mobileNumber?.isValid)}
              errorMessage={
                errors?.mobileNumber?.message ||
                "Enter a valid 8-digit Singapore mobile number"
              }
              inputProps={{
                textAlign: "left",
                value: values["mobileNumber"],
              }}
              inputType={"input"}
              onBlurShowError
            />
            <InputGroup
              labelColor="#434343"
              id="email"
              name="email"
              label="Email"
              placeholder="John@singlife.com"
              onFocus={onFocusField}
              onChange={(e) => {
                onInputChange("email", e);
              }}
              invalid={!isEmpty(errors?.email?.message)}
              errorMessage={errors?.email?.message}
              inputProps={{
                textAlign: "left",
                value: values["email"],
              }}
              onBlurShowError={true}
              inputType={"input"}
              theme={themeDefault}
            />
          </ContactInputContainer>
          <FormActionContainer>
            <Button
              width="180px"
              variant="default"
              label="Submit"
              disabled={!formValid}
              theme={themeDefault}
              onClick={onSubmit}
            />
          </FormActionContainer>
          <SubmitNote theme={theme}>
            By clicking "Submit", you consent to Singapore Life Ltd (“Singlife”)
            collecting, using, disclosing or transferring your personal data to
            Singlife related companies, third party service providers or
            intermediaries (including your financial adviser, where applicable)
            whether located in Singapore or elsewhere, to assist you with your
            application. You can refer to{" "}
            <Link
              theme={themeDefault}
              target="_blank"
              rel="noopener noreferrer"
              url={ContactUsUrl}
              text={`Singlife's Data Protection Notice`}
            />{" "}
            for further details. If you wish to withdraw your consent, you may
            contact Singlife at{" "}
            <Link
              theme={themeDefault}
              url="mailto:cs_life@singlife.com"
              text="cs_life@singlife.com"
            />{" "}
            or{" "}
            <Link
              theme={themeDefault}
              url="tel:+6568279933"
              text="+65 6827 9933"
            />
          </SubmitNote>
          <Contactus
            descriptionClass={descriptionClass}
            findoutLink={{ default: 14, tablet: 14 }}
            color={themeDefault.colors.primary}
            cardLinkClass={{ default: 14, tablet: 14 }}
            cardInfoHeadingClass={font18}
          />
        </ContacFormContainer>
      </>
    </HealthMainContainer>
  ) : (
    <SubmitSuccess />
  );
};
export default ContactForm;

const descriptionClass = css`
  font-size: 14px;
`;
const font18 = css`
  font-size: 18px;
`;
